import { TFunction } from 'i18next';
import { object, string, array } from 'yup';
import { IOrgRoles } from '~/Models/interfaces/OrgStaff.model';

export const staffValidationScheme = (t: TFunction) => {
  const getMessage = (field: string) => t('form.field.message.required', { field });
  const error = {
    required: {
      firstName: getMessage(t('app.firstName')),
      lastName: getMessage(t('app.lastName')),
      email: getMessage(t('app.customer.fitogramAccount.email')),
      roles: getMessage(t('form.title.staffAccess')),
    },
  };

  return object({
    firstName: string().required(error.required.firstName),
    lastName: string().required(error.required.lastName),
    email: string().required(error.required.email),
    roles: array<IOrgRoles>().required(error.required.roles),
  });
};
